<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0 ;  height: 100%">
    <van-cell-group>
<!--      <van-cell title="四好运动员" is-link @click="toNext('ClubDetailSihao')"></van-cell>-->
<!--      <van-cell title="五星俱乐部" is-link></van-cell>-->
      <van-cell title="四好运动员" is-link></van-cell>
      <van-cell title="优秀领队" is-link></van-cell>
      <van-cell title="优秀裁判员" is-link></van-cell>
      <van-cell title="优秀教练员" is-link></van-cell>
<!--      <van-cell title="已申报的四好运动员" is-link @click="toNext('ClubDetailSihaoApplySuccess')"></van-cell>-->
<!--      <van-cell title="四好运动员展示" is-link></van-cell>-->
      <div style="height: 10px"></div>
    </van-cell-group>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
  </div>
</template>
<style scoped>
.kaoji-title {
  padding: .3rem;
  font-size: 24px;
  text-align: center;
}

.kaoji-mine {
  padding: 0 .3rem .4rem;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-right: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'ClubDetailSihao',
  components: {
    PicUploader,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      id: 0,
      row: {}
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.id = this.$route.query.id;
    document.title = "风采展示"
    this.fetch();

  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    fetch() {
      let that = this;
      that.$api.post('/api/club/clubDetail', {
        id : that.id,
      }, (res) => {
        that.row = res.data;
      }, (res) => {
//                    Toast.fail(res.msg);
      })
    },
    unbind() {
      let that = this;
      Dialog.confirm({
        title: '确认',
        message: '确认要解除单位认证吗?'
      }).then(() => {

        that.$api.post('/api/danwei/unbind', {}, (res) => {
          that.fetch();
        }, (res) => {

        })

//                    that.onPaySuccess();
      }).catch(() => {
//                    that.onPayError();
      });
    },

    toNext(name) {
      rbLink({name:name, query: {id: this.row.id} })
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

  }
}
</script>



// WEBPACK FOOTER //
// ClubDetailFengcai.vue?36c78f68